export default __webpack_public_path__ + "static/media/img-b-charge-car.bbad3009.png";